import React from 'react'
import {AddInternalNote, PatientDetailsEdit} from './modalsComponents'

const Modals = () => {
  return (
    <>
      <PatientDetailsEdit />
      <AddInternalNote />
    </>
  )
}

export default Modals